/**
 * useMenuSource — query GET /api/menu/source (ADR-0031).
 *
 * Paletka buildera: aktywne moduły (catalog + subscriptions), custom modules,
 * 6 stałych system items.
 *
 * staleTime 5 min — moduły/subskrypcje nie zmieniają się często.
 */

import type { MenuSourceResponse } from '@saas/shared';
import { useQuery } from '@tanstack/react-query';

import { api } from '@/lib/api';

export const MENU_SOURCE_QUERY_KEY = ['tenant', 'menu', 'source'] as const;

export function useMenuSource(opts?: { enabled?: boolean }) {
  return useQuery<MenuSourceResponse>({
    queryKey: MENU_SOURCE_QUERY_KEY,
    queryFn: async () => {
      const res = await api.get<MenuSourceResponse>('/menu/source');
      return res.data;
    },
    enabled: opts?.enabled ?? true,
    staleTime: 5 * 60_000,
  });
}
